var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bookings-current-month'),_c('bookings-by-day'),_c('annual-graph'),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('annual-companies-transactions')],1),_c('b-col',{attrs:{"md":"6"}},[_c('taxi-balance-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }